import { Provider } from '@angular/core';

import { MotManageVacationsRepositoryImpl } from '@app/data/repositories/manage-vacations/mot/mot-manage-vacations.repository';
import { MOT_MANAGE_VACATIONS_REPOSITORY } from '@app/domain/repositories/manage-vacations/mot/mot-manage-vacations.repository.contract';

export const motManageVacationsRepositoryProvider: Provider = {
  provide: MOT_MANAGE_VACATIONS_REPOSITORY,
  useClass: MotManageVacationsRepositoryImpl
};
